module.exports = __webpack_public_path__ + "static/Resume-b98b70cd6f3014d117b52e4f75c61a5e.pdf";